module.exports = __webpack_public_path__ + "img/share.c634c740.svg";